import { OwcTypography } from "@one/react";
import styles from "./WelcomeScreen.module.scss";
import { react18WorkaroundProps } from "../utils/constants/react18WorkaroundProps";

const WelcomeScreen = ({ text = "You must login to view equipment" }) => {
  return (
    <div className={styles.welcomeScreenWrapper} data-testid="main-page-not-authenticated-with-no-error-by-backend">
      <OwcTypography {...react18WorkaroundProps} style={{ color: "inherit" }} variant="title2">
        Equipment Repository
      </OwcTypography>
      <OwcTypography {...react18WorkaroundProps} style={{ color: "inherit" }} variant="title2">
        Welcome
      </OwcTypography>
      <div className={styles.wrapTitle5}>
        <OwcTypography {...react18WorkaroundProps} style={{ color: "inherit" }} variant="title5">
          {text}
        </OwcTypography>
      </div>
    </div>
  );
};

export default WelcomeScreen;
